var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19.17,
  height: 19.169,
  viewBox: "0 0 19.17 19.169"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-558.9 -959.93)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.205,
  cy: 6.205,
  rx: 6.205,
  ry: 6.205,
  transform: "translate(562.28 963.31)",
  fill: "#ffc850"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.222,
  cy: 5.221,
  rx: 5.222,
  ry: 5.221,
  transform: "translate(563.264 964.293)",
  fill: "#ffdc64"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.984,
  cy: 0.984,
  r: 0.984,
  transform: "translate(570.116 966.243)",
  fill: "#fff082"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.539,158.692a4.617,4.617,0,0,1-3.793-3.946,4.571,4.571,0,0,1,.2-2.022.342.342,0,0,0-.519-.385,4.588,4.588,0,1,0,5.93,6.928.342.342,0,0,0-.3-.575A4.548,4.548,0,0,1,138.539,158.692Z",
  transform: "translate(431.482 813.381)",
  fill: "#ffc850"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.288,151.568v-2.206c.867.1,1.476.5,1.476.858a.41.41,0,0,0,.82,0c0-.866-.98-1.559-2.3-1.681v-.267a.41.41,0,1,0-.82,0v.267c-1.315.121-2.3.815-2.3,1.681,0,1.162,1.053,1.62,2.3,1.972V154.4c-.867-.1-1.476-.5-1.476-.858a.41.41,0,0,0-.82,0c0,.866.98,1.559,2.3,1.681v.267a.41.41,0,1,0,.82,0v-.267c1.315-.121,2.3-.815,2.3-1.681C188.583,152.378,187.53,151.921,186.288,151.568Zm-2.3-1.348c0-.361.609-.759,1.476-.858v1.975C184.376,151,183.992,150.7,183.992,150.22Zm2.3,4.179v-1.975c1.092.336,1.476.639,1.476,1.117C187.763,153.9,187.155,154.3,186.288,154.4Z",
  transform: "translate(382.607 817.635)",
  fill: "#e1a546"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.982,0a9.424,9.424,0,0,0-7.029,3.121l.159-1.112a.327.327,0,1,0-.648-.093l-.327,2.289a.327.327,0,0,0,.324.373.321.321,0,0,0,.1-.017l1.962-.654a.327.327,0,0,0-.207-.62l-.911.3a8.829,8.829,0,1,1,6.574,14.724.327.327,0,0,0,0,.654A9.485,9.485,0,0,0,51.982,0Z",
  transform: "translate(516.505 960.03)",
  fill: "#36c626",
  stroke: "#36c626",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(559 965.226)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M203.8,491.133a.287.287,0,0,1-.047,0q-.169-.024-.336-.054a.328.328,0,0,1,.117-.645c.1.019.208.035.312.051a.328.328,0,0,1-.046.652Z",
  transform: "translate(-195.599 -477.452)",
  fill: "#36c626",
  stroke: "#36c626",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.644,193.52a.325.325,0,0,1-.1-.016c-.209-.069-.417-.145-.618-.227a.328.328,0,0,1,.248-.607c.187.076.38.147.575.211a.328.328,0,0,1-.1.64Zm-1.736-.779a.325.325,0,0,1-.164-.044c-.188-.109-.375-.226-.557-.35a.328.328,0,0,1,.368-.543c.169.115.344.224.518.325a.328.328,0,0,1-.165.612ZM3.37,191.622a.328.328,0,0,1-.219-.084c-.162-.146-.321-.3-.473-.456a.328.328,0,0,1,.471-.456q.213.22.441.425a.328.328,0,0,1-.219.572ZM2.1,190.211a.327.327,0,0,1-.265-.134c-.129-.176-.253-.359-.37-.544a.328.328,0,1,1,.555-.35q.163.259.344.506a.328.328,0,0,1-.264.522Zm-.958-1.643a.328.328,0,0,1-.3-.193c-.09-.2-.174-.4-.25-.609a.328.328,0,1,1,.615-.227c.07.19.148.38.232.566a.328.328,0,0,1-.3.463Zm-.6-1.805a.328.328,0,0,1-.32-.258c-.047-.215-.087-.433-.118-.647a.328.328,0,1,1,.649-.095c.029.2.066.4.11.6a.327.327,0,0,1-.25.39A.314.314,0,0,1,.539,186.763Zm-.211-1.89A.328.328,0,0,1,0,184.55v-.084q0-.29.017-.575a.334.334,0,0,1,.347-.307.328.328,0,0,1,.307.347q-.016.266-.016.535v.076a.328.328,0,0,1-.324.332Zm.179-1.894a.324.324,0,0,1-.065-.006.328.328,0,0,1-.257-.386c.043-.212.094-.427.151-.639a.328.328,0,0,1,.633.172q-.08.294-.141.6A.328.328,0,0,1,.508,182.98Z",
  transform: "translate(0 -180.203)",
  fill: "#36c626",
  stroke: "#36c626",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.472,142.2a.328.328,0,0,1-.3-.457c.045-.1.092-.208.14-.31a.328.328,0,1,1,.592.282q-.068.142-.13.287A.328.328,0,0,1,20.472,142.2Z",
  transform: "translate(-19.396 -141.246)",
  fill: "#36c626",
  stroke: "#36c626",
  strokeWidth: 0.2
})))));
export default __webpack_public_path__ + "static/media/doller-circle.268a6f44.svg";
export { SvgComponent as ReactComponent };